export const getFormikValue = (values: any, fieldName: string) =>
  values[fieldName];
